import { Headline, TextButton } from '@oneaudi/unified-web-alpha-components';
import { useI18n } from '~/app/i18n/i18n';
import { DATA_TEST_ID } from '~/test/data-test-id';
import { StyledSection } from './gpsr-section-style';

export const GPSRSection = () => {
	const { i18n } = useI18n();

	const isGPSRUrlConfigured = Boolean(i18n('ngc.gpsr.url'));

	if (!isGPSRUrlConfigured) return null;

	return (
		<StyledSection data-testid={DATA_TEST_ID.SUMMARY_GPSR_CONTAINER}>
			<Headline tag="h3" variant={{ type: 'headline', order: '3', weight: 'normal' }}>
				{i18n('ngc.gpsr.headline')}
			</Headline>

			<TextButton
				className={'main-cta-button'}
				isFullWidth
				variant={'secondary'}
				href={i18n('ngc.gpsr.url')}
				size={'md'}
				target={'_blank'}>
				{i18n('ngc.gpsr.buttonLabel')}
			</TextButton>
		</StyledSection>
	);
};
